import { Component } from '@angular/core';

@Component({
  selector: 'app-banner-page-root',
  templateUrl: './default-page-root.component.html',
  styleUrls: ['./default-page-root.component.scss']
})
export class DefaultPageRootComponent { }
